import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MainService } from '../../service/main.service';
import { ApiUrls } from '../../apiRouts';
import { ToasterServiceService } from '../../service/toaster.service';
import { LocalStorageService } from '../../service/local-storage.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss'
})
export class FooterComponent {
  selectedPath: any;
  userTypeId: any;
  user_id: any;
  constructor(
    private route: Router,
    private mainService: MainService,
    private toasterService: ToasterServiceService,
    private localStorageService: LocalStorageService
  ) {
  }

  logOut() {
    // this.closeSideBar();
    // let fcm_token = this.localStorageService.getItem("firebaseToken") || "";
    // let data = {
    //   fcm_token: fcm_token
    // };
    // this.mainService.postApi(ApiUrls.userLogout, data, 1).subscribe((res: any) => {
    //   if (res.status === 1) {
    //     this.toasterService.toastSuccess("Logout Successfully");
    //     this.route.navigate(['/auth/login']);
    //     localStorage.clear();
    //     this.localStorageService.setData("firebaseToken", fcm_token);
    //   } else {
    //     this.toasterService.toastError('Logout Failed');
    //   }
    // });
    this.localStorageService.deleteAllData();
    this.route.navigate(['/auth/login']);
  }

}
